import { DvTextareaCellEditorParams, DvToolbarAction } from '@devinco/ui/grid';
import { Injectable, inject } from '@angular/core';
import { RestApiService } from '@core/services/rest-api.service';
import { UserRolesAndPermissionsService } from '@core/services/user-roles-and-permissions.service';
import { ColumnType } from '@features/vt-grid/grid-options/column-types';
import { getStandardActionPreset } from '@features/vt-grid/presets/preset-actions';
import { Entity } from '@shared/constants/entity';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { EntityleFieldsValuesDto } from '@shared/interfaces/entity-fields-values';
import { ColDef } from 'ag-grid-community';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserPropertiesGridService {
  private api = inject(RestApiService);
  private rolesAndPermissionsSercvice = inject(UserRolesAndPermissionsService);

  getGridActions = (): DvToolbarAction[] => getStandardActionPreset();
  getColumnDefs(): ColDef<EntityleFieldsValuesDto>[] {
    return [
      {
        field: 'EntityFieldID',
        type: ColumnType.Id,
        hide: true,
        headerName: 'General.Id',
      },
      {
        field: 'FieldDescription',
        type: ColumnType.Text,
        headerName: 'UserPropertiesGrid.FieldDescription',
        flex: 1,
      },
      {
        field: 'FieldValue',
        editable: this.rolesAndPermissionsSercvice
          .getPermissionsArray()
          ?.some(permission => permission === RolesAndPermissions.UserEdit),
        cellEditorPopup: true,
        cellEditor: 'agLargeTextCellEditor',
        onCellValueChanged: params => {
          if (params.oldValue === params.newValue) return;

          const payload: Partial<EntityleFieldsValuesDto> = {
            EntityFieldID: params.data.EntityFieldID,
            FieldValue: params.newValue,
          };
          this.api
            .upsert(
              Entity.UserFieldsValues,
              params.context.extraFilter['EntityID'].filter,
              payload
            )
            .pipe(take(1))
            .subscribe(() => {
              params.api.flashCells({
                rowNodes: [params.node!],
                columns: ['FieldValue'],
              });
            });
        },
        cellEditorParams: {
          maxLength: 4000,
          height: '100px',
          width: '400px',
        } as DvTextareaCellEditorParams,
        cellEditorPopupPosition: 'over',
        type: ColumnType.Text,
        headerName: 'UserPropertiesGrid.FieldValue',
        flex: 2,
      },
    ];
  }
}
